import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/CustomReport";

export const getCustomReports = async () => {
  const data = await axios.get(`${api_base_url}`);
  return data;
};

export const addCustomReport = async (addCustomReport) => {
  const data = await axios.post(`${api_base_url}/AddCustomReport`, {
    ...addCustomReport,
  });
  return data;
};

export const updateCustomReport = async (updateCustomReport) => {
  const data = await axios.put(`${api_base_url}/UpdateCustomReport`, {
    ...updateCustomReport,
  });
  return data;
};
export const getModules = async () => {
  const { data } = await axios.get(`${api_base_url}/GetModules`);
  return data;
};

export const getActiveRoles = async () => {
  const { data } = await axios.get(`${api_base_url}/GetActiveRoles`);
  return data;
};

export const getDynamicData = async (reportName) => {
  const report = reportName?.replace(" ", "");
  return await axios
    .get(`${api_base_url}/GetDynamicData/${report}`)
    .then((res) => {
      try {
        if (res?.data) {
          const colData = res?.data?.map((x) => {
            return {
              ...x,
            };
          });
          const col: any[] = Object?.keys(res?.data?.[0])
            ?.filter((y) => y !== "row_num")
            ?.map((y: string) => {
              const words = y?.split(/(?=[A-Z])/);

              // Capitalize the first letter of each word and join them with a space
              const formattedName = words
                ?.map((word) => word.charAt(0).toUpperCase() + word?.slice(1))
                ?.join(" ");

              return {
                accessorKey: y,
                header: formattedName,
              };
              // return {
              //   name: formattedName,
              //   cell: (row: any) => row[y],
              // };
            });
          return {
            data: colData,
            column: col,
          };
        } else {
          return {
            data: [],
            column: [],
          };
        }
      } catch {
        return {
          data: [],
          column: [],
        };
      }
    });
};

export const getCustomQuery = async (columns) => {
  return await axios
    .post(`${api_base_url}/GetCustomQuery`, { ...columns })
    .then((res) => {
      try {
        if (res?.data) {
          const colData = res?.data?.map((x) => {
            return {
              ...x,
            };
          });
          const col: any[] = Object?.keys(res?.data?.[0])
            ?.filter((y) => y !== "row_num")
            ?.map((y: string) => {
              const words = y?.split(/(?=[A-Z])/);

              // Capitalize the first letter of each word and join them with a space
              const formattedName = words
                ?.map((word) => word.charAt(0).toUpperCase() + word?.slice(1))
                ?.join(" ");
              //MRTable
              return {
                accessorKey: y,
                header: formattedName,
              };
            });
          return {
            data: colData,
            column: col,
          };
        } else {
          return {
            data: [],
            column: [],
          };
        }
      } catch {
        return {
          data: [],
          column: [],
        };
      }
    });
};

export const getModuleColumns = async (moduleName: string) => {
  const module = moduleName?.includes("&")
    ? moduleName?.replace("&", "And")
    : moduleName;

  return await axios
    .get(`${api_base_url}/GetModuleColumns?moduleName=${module}`)
    .then((res) => {
      try {
        if (res) {
          const columns = Object?.values(res?.data?.[0])
            ?.filter((y) => y !== "row_num")
            ?.map((y) => {
              return {
                label: y,
                value: y,
              };
            });
          return columns;
        } else {
          return [];
        }
      } catch {
        return [];
      }
    });
};

export const getReportsTab = async () => {
  return await axios.get(`${api_base_url}/GetReportsTab`).then((res) => {
    return res?.data;
  });
};

export const getDetailsForEdit = async (id: number) => {
  const { data } = await axios.get(`${api_base_url}/ForEdit/${id}`);
  return data;
};

export const getDeactivateById = async (ids) => {
  return await axios.delete(`${api_base_url}/DeactivateById`, { data: ids });
};
